import { render, staticRenderFns } from "./FeeBudget.vue?vue&type=template&id=35bf8d62"
import script from "./FeeBudget.vue?vue&type=script&lang=js"
export * from "./FeeBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports